<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/deviceType' }">设备类型</el-breadcrumb-item>
            <el-breadcrumb-item>添加类型</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="设备名称" prop="name">
                    <el-col :span="8">
                        <el-input v-model="form.name"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="设备型号" prop="model">
                    <el-col :span="8">
                        <el-input v-model="form.model"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="设备充值价格（元/次）" prop="price">
                    <el-col :span="8">
                        <el-input v-model="form.price"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="key1" prop="key1">
                    <el-col :span="8">
                        <el-input v-model="form.key1"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="key2" prop="key2">
                    <el-col :span="8">
                        <el-input v-model="form.key2"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/deviceType";
    export default {
        data: function () {
            return {
                form: {
                    useableCount: 0,
                },
                loading: false,
                rules: {
                    name: [{required: true, message: "请输入设备名称", trigger: "blur"}],
                    model: [{required: true, message: "请输入设备型号", trigger: "blur"}],
                    price: [{required: true, message: "请输入设备价格", trigger: "blur"}],
                    key1: [{required: true, message: "请填写key1", trigger: "blur"}],
                    key2: [{required: true, message: "请填写key2", trigger: "blur"}],
                },
            }
        },
        mounted: function() {
            this.loadLast();
        },
        methods: {
            loadLast: function() {
                deviceApi.findLast().then(res => this.form = res);
            },
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    deviceApi.create(this.form).then(result => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '创建成功!'
                        });
                        this.$router.back();
                    }).catch(() => loading.close());
                })

            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
